<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
    min-width: 1300px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue